import React  from 'react';

import ChangePasswordContent from "../content/ChangePasswordContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function ChangePassword() {
    return(
        <>
        <Navbar />
        <ChangePasswordContent/>
        <Footer />        
        </>
    );
}

export default ChangePassword;